import { Factory, Target, Compass, Award } from "lucide-react";
import { PageHero, CTABand, SectionHead, Reveal } from "@/components/Bits";

const VALUES = [
  { icon: Compass, t: "Engenharia", d: "Dimensionamento próprio e projeto para cada aplicação." },
  { icon: Factory, t: "Indústria", d: "Capacidade de fabricação de equipamentos sob encomenda." },
  { icon: Award, t: "Confiabilidade", d: "Foco em robustez, durabilidade e assistência de longo prazo." },
  { icon: Target, t: "Tecnologia", d: "Soluções eficientes, com controle e automação." },
];

export default function Empresa() {
  return (
    <div>
      <PageHero eyebrow="A Empresa" title="Da refrigeração ao equipamento: uma marca que fabrica."
        subtitle="A Global Refrigeração nasceu da experiência técnica em refrigeração e se posiciona hoje como fabricante de equipamentos industriais e comerciais."
        image="https://images.unsplash.com/photo-1647427060118-4911c9821b82?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600" />

      <section className="mx-auto max-w-[1400px] px-4 py-20 lg:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2">
          <div>
            <SectionHead eyebrow="Quem somos" title="Experiência técnica que virou capacidade de fabricação" />
            <div className="space-y-4 text-[#A1A1AA]">
              <p>Somos uma operação de refrigeração com forte base técnica, agora estruturada para <span className="text-white">projetar, dimensionar e fabricar</span> equipamentos de refrigeração industrial e comercial.</p>
              <p>Trabalhamos no modelo de <span className="text-white">fabricação sob encomenda</span>: você traz a aplicação, nós dimensionamos, fabricamos, testamos, entregamos e prestamos assistência — reduzindo estoque e capital parado.</p>
              <p>Começamos forte em <span className="text-white">Santa Catarina</span> (Joinville, Jaraguá do Sul, Blumenau, Itajaí) e atendemos todo o Brasil.</p>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-px border border-[#27272A] bg-[#27272A]">
            {VALUES.map((v) => (
              <div key={v.t} className="bg-[#0A0A0B] p-8">
                <v.icon className="h-8 w-8 text-[#FF5500]" />
                <h3 className="font-heading mt-4 text-lg font-bold text-white">{v.t}</h3>
                <p className="mt-2 text-sm text-[#A1A1AA]">{v.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="border-t border-[#27272A] bg-[#0A0A0B]">
        <div className="mx-auto max-w-[1400px] px-4 py-20 lg:px-8">
          <SectionHead eyebrow="Como trabalhamos" title="Do contato à entrega" />
          <div className="grid grid-cols-2 gap-px border border-[#27272A] bg-[#27272A] md:grid-cols-4">
            {["Contato & Qualificação", "Dimensionamento & Proposta", "Fabricação & Teste", "Entrega, Instalação & Pós-venda"].map((s, i) => (
              <Reveal key={s} delay={i * 0.06}>
                <div className="h-full bg-[#0A0A0B] p-6">
                  <div className="font-heading text-3xl font-black text-[#FF5500]">{String(i + 1).padStart(2, "0")}</div>
                  <p className="mt-3 text-sm font-medium text-white">{s}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <CTABand />
    </div>
  );
}
